import { useEffect, useState } from "react";
import { AiOutlineDislike, AiOutlineLike } from "react-icons/ai";
import { BsInfo } from "react-icons/bs";
import UpdatePromptRLStatusModal from "../GeoSetup/GeoPrompts/UpdatePromptRLStatusModal";
import GeoPromptInfoModal from "../GeoSetup/GeoPrompts/GeoPromptInfoModal";
import GeoPromptsLoader from "../../Loaders/GeoPromptsLoader";

const GeoPromptsMain = ({
    account_id,
    org_id,
    geo_id,
    getPrompts,
    prompts,
    setLoadingPrompts,
    loadingPrompts
}) => {
    const [openUpdatePrompt, setOpenUpdatePrompt] = useState(false)
    const [selectedPrompt, setSelectedPrompt] = useState({})
    const [openDeletePromptModal, setOpenDeletePromptModal] = useState(false)
    const [selectedStatusRL, setSelectedStatusRL] = useState(null)
    const [openInfoModal, setOpenInfoModal] = useState(false)

    const handleRlPrompt = (prompt, status) => {
        setSelectedPrompt(prompt)
        setSelectedStatusRL(status)
        setOpenUpdatePrompt(true)
    }

    const handleOpenInfoModal = (prompt) => {
        setSelectedPrompt(prompt)
        setOpenInfoModal(true)
    }

    const handleDeletePrompt = (prompt) => {
        setSelectedPrompt(prompt)
        setOpenDeletePromptModal(true)
    }

    useEffect(() => {
        getPrompts()
    }, [account_id, org_id, geo_id]);

    return (
        <div className="geo_item_overview_cont">
            {loadingPrompts ? (
                <GeoPromptsLoader />
            ) : (

                <div className="geo_item_overview_cont_item_cont">
                    {prompts?.map((prompt, index) => (
                        <div key={prompt.id} className={`prompts_item fade-in ${prompt.id.startsWith("prompt-0-0-") && "prompts_item_custom"}`}>
                            <p>"{prompt.prompt}"</p>
                            <div className="prompts_item_footer">
                                <div className="prompts_item_footer_btn_cont">
                                    <button
                                        className={`prompts_item_btn ${prompt.rl_status == "POSITIVE" && "prompts_item_btn_selected"}`}
                                        onClick={() => handleRlPrompt(prompt, "POSITIVE")}
                                    >
                                        <AiOutlineLike />
                                    </button>
                                    <button
                                        className={`prompts_item_btn ${prompt.rl_status == "NEGATIVE" && "prompts_item_btn_selected"}`}
                                        onClick={() => handleRlPrompt(prompt, "NEGATIVE")}
                                    >
                                        <AiOutlineDislike />
                                    </button>
                                    <button
                                        className="prompts_item_btn"
                                        onClick={() => handleOpenInfoModal(prompt)}
                                    >
                                        <BsInfo />
                                    </button>
                                </div>
                                {/* <div className="prompts_item_footer_btn_cont">
                                    <button
                                        className="prompts_item_btn"
                                        onClick={() => handleDeletePrompt(prompt)}
                                    >
                                        <LuTrash2 />
                                    </button>
                                </div> */}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <UpdatePromptRLStatusModal
                account_id={account_id}
                org_id={org_id}
                geo_id={geo_id}
                show={openUpdatePrompt}
                handleClose={() => setOpenUpdatePrompt(false)}
                selectedPrompt={selectedPrompt}
                selectedStatusRL={selectedStatusRL}
                getPrompts={getPrompts}
            />

            <GeoPromptInfoModal
                show={openInfoModal}
                handleClose={() => setOpenInfoModal(false)}
                selectedPrompt={selectedPrompt}
            />

            {/* <DeleteItemModal
                account_id={account_id}
                show={openDeletePromptModal}
                handleClose={() => setOpenDeletePromptModal(false)}
                fetchRecords={getPrompts}
                item={selectedPrompt}
                endpoint={"delete_prompt"}
                title={t.geo.delete_prompt}
                description={t.geo.delete_prompt_desc}
                input_value={selectedPrompt}
            /> */}
        </div>
    )
}

export default GeoPromptsMain